const THREATS = [
  { sev: "high", text: "Brute-force burst · auth gateway", state: "blocked" },
  { sev: "med", text: "S3 bucket ACL drift · prod-assets", state: "contained" },
  { sev: "low", text: "Stale PAT rotated · ci-runner", state: "resolved" },
  { sev: "high", text: "Credential stuffing · 412 IPs", state: "blocked" },
  { sev: "med", text: "Privilege escalation attempt", state: "contained" },
  { sev: "low", text: "Dependency CVE patched · lodash", state: "resolved" },
];

const BLIPS = [
  { x: 28, y: 36 },
  { x: 66, y: 30 },
  { x: 72, y: 66 },
  { x: 36, y: 70 },
];

function renderThreat(t) {
  return `
    <div class="sec-stage__threat sec-stage__threat--${t.sev}">
      <i></i>
      <span>${t.text}</span>
      <b>${t.state}</b>
    </div>
  `;
}

export function createCyberSecurityStage() {
  const wrap = document.createElement("div");
  wrap.className = "services-stage services-stage--cyber reveal";
  wrap.style.setProperty("--delay", "0.18s");
  wrap.setAttribute("aria-hidden", "true");

  wrap.innerHTML = `
    <div class="services-stage__glow"></div>
    <div class="services-stage__orb services-stage__orb--a"></div>
    <div class="services-stage__orb services-stage__orb--b"></div>
    <div class="services-stage__orb services-stage__orb--c"></div>

    <div class="services-stage__window services-stage__panel">
      <div class="services-stage__chrome">
        <span class="services-stage__dot services-stage__dot--r"></span>
        <span class="services-stage__dot services-stage__dot--y"></span>
        <span class="services-stage__dot services-stage__dot--g"></span>
        <span class="services-stage__path">sec.console / posture</span>
        <span class="services-stage__live"><span></span>monitoring</span>
      </div>

      <div class="sec-stage">
        <div class="sec-stage__radar">
          <i class="sec-stage__ring"></i>
          <i class="sec-stage__ring"></i>
          <i class="sec-stage__ring"></i>
          <i class="sec-stage__axis"></i>
          <i class="sec-stage__axis sec-stage__axis--v"></i>
          <span class="sec-stage__sweep"></span>
          ${BLIPS.map((b, i) => `<span class="sec-stage__blip" style="--x: ${b.x}%; --y: ${b.y}%; --i: ${i}"></span>`).join("")}
          <div class="sec-stage__shield">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M12 2.5 4 5.5v6c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10v-6l-8-3Z" fill="#c8f04d" stroke="#1c242c" stroke-width="1.4" stroke-linejoin="round"/>
              <path d="m8.8 12.2 2.2 2.2 4.4-4.6" stroke="#1c242c" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <strong data-score>96</strong>
            <small>Posture</small>
          </div>
        </div>

        <div class="sec-stage__side">
          <div class="sec-stage__kpis">
            <div><strong data-blocked>1,284</strong><small>Blocked · 24h</small></div>
            <div><strong>12m</strong><small>MTTD</small></div>
            <div><strong>0</strong><small>Breaches</small></div>
          </div>

          <div class="sec-stage__stream">
            <span class="sec-stage__eyebrow">Live threats</span>
            <div class="sec-stage__feed" data-feed></div>
          </div>

          <div class="sec-stage__controls">
            <span class="sec-stage__control is-on">SSO + MFA<b>enforced</b></span>
            <span class="sec-stage__control is-on">Least privilege<b>audited</b></span>
            <span class="sec-stage__control">Secrets rotation<b>every 30d</b></span>
          </div>
        </div>
      </div>

      <div class="services-stage__footer">
        <span>Threat model</span>
        <span>Identity first</span>
        <span class="services-stage__pulse" data-pulse>scanning estate</span>
      </div>
    </div>
  `;

  bindSecRuntime(wrap);
  return wrap;
}

function bindSecRuntime(root) {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const feed = root.querySelector("[data-feed]");
  const blocked = root.querySelector("[data-blocked]");
  const score = root.querySelector("[data-score]");
  const pulse = root.querySelector("[data-pulse]");
  const pulses = ["scanning estate", "signals correlated", "playbook 04 ran", "posture updated"];

  if (!feed) return;

  let step = 0;
  let count = 1284;
  let timer = null;

  const push = () => {
    feed.insertAdjacentHTML("afterbegin", renderThreat(THREATS[step % THREATS.length]));
    while (feed.children.length > 3) feed.lastElementChild?.remove();
  };

  push();
  push();
  push();

  if (reduced) return;

  const tick = () => {
    step += 1;
    push();
    count += 3 + (step % 4);
    if (blocked) blocked.textContent = count.toLocaleString("en-US");
    if (score) score.textContent = String(95 + (step % 3));
    if (pulse) pulse.textContent = pulses[step % pulses.length];
  };

  const start = () => {
    if (timer) return;
    timer = window.setInterval(tick, 2400);
  };
  const stop = () => {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  };

  start();
  new IntersectionObserver(([entry]) => (entry.isIntersecting ? start() : stop()), {
    threshold: 0.2,
  }).observe(root);
}
